import { useAccountHierarchyAPIInterface } from "@dealer-center/ddc-pages-account-hierarchy-fetch";

import { useEffect, useState } from "react";
import { PagesAccountHierarchyUiDisplay } from "./Display";

export const PagesAccountHierarchyUi = () => {
  const [nameInput, setNameInput] = useState("");
  const [name, setName] = useState("");
  const { data, error, isLoading } = useAccountHierarchyAPIInterface({ name });
  useEffect(() => {
    document.title = "AccountHierarchy";
  }, []);
  return (
    <PagesAccountHierarchyUiDisplay
      data={data}
      error={error ? error.message : undefined}
      loading={isLoading}
      nameInput={nameInput}
      setName={setName}
      setNameInput={setNameInput}
    />
  );
};
